import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  close: 'Close',
  back: 'Back',
  retry: 'Try again',
  cancel: 'Cancel',
  confirm: 'Confirm',
  continue: 'Continue',
  save: 'Save',
  edit: 'Edit',
  remove: 'Remove',
  see: 'View',
  seeMore: 'See more',
  signIn: 'Sign in',
  signUp: 'Create an account',
  backHome: 'Back to home',
  loading: 'Loading',
  new: 'New',
  soon: 'Soon',
  total: 'Total',
  'stepper.remove': 'Remove: {label}',
  'stepper.add': 'Add: {label}',
  'calendar.previous': 'Previous month',
  'calendar.next': 'Next month',
  'calendar.unavailable': '{day}, unavailable',
  'stars.label': 'Rating',
  'stars.value': '{label}: {value} out of 5',
  'stars.option': '{value} out of 5',
  'brand.home': 'Cardnd, home',
  vehicles: 'Vehicles',
  experiences: 'Experiences',
  cars: 'Cars',
  motos: 'Motorbikes',
  favourites: 'Favourites',
  messages: 'Messages',
  profile: 'Profile',
  allCategories: 'All',
  'seo.siteDescription':
    'Rent a car or a motorbike, or book an experience, with verified agencies in Morocco. Total price shown, secure payment.',
});
